import { useStores } from "../../core/stores/rootStore";
import React, { useContext, useEffect, useState,useRef } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { observer } from "mobx-react";
import { useTranslation, Trans } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Button from 'react-bootstrap/Button';
import Stack from 'react-bootstrap/Stack';
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card';
import Pagination from 'react-bootstrap/Pagination';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { StyledDropZone } from 'react-drop-zone'
import 'react-drop-zone/dist/styles.css'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import Placeholder from 'react-bootstrap/Placeholder';
import Container from 'react-bootstrap/Container';
import FormText from './../inputs/text';

import 'react-quill/dist/quill.snow.css';
import { prepareForm } from './../../utils';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

const WinbizSettings = () => {

    let navigate = useNavigate();
    const { usersAdminStore, clientsStore, companiesStore, utilsStore, winbizStore } = useStores();
    const { searchCompany } = companiesStore;
    const { searchConsultant } = usersAdminStore;
    const { getCurrencies,currencies } = utilsStore;
    const { getById, client, reset, save } = clientsStore;
    const { config, getConfig, saveConfig } = winbizStore;
    
    const { t, i18n } = useTranslation();    
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(false);   
    const [validated, setValidated] = useState(false);
    const formRef = useRef(null);
    

    useEffect(() => {        
        
        setIsLoading(true);
        Promise.all([getConfig()]).then(() => { setIsLoading(false); })        

    }, [getConfig]);

       
    const handleSubmit = (event) => {
        
        event.preventDefault();

        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {            
            var formData = prepareForm(event, false);            
            saveConfig(formData, () => { /*goToList()*/ });
        }

        setValidated(true);
    };

    const goToList = () => {
        navigate("/administration/clients")
    };
    
    return (       
        <Form noValidate validated={validated} onSubmit={handleSubmit} ref={formRef}>
            <Card>                
                <Card.Body>
                    <div>                      
                        <Stack direction="vertical">
                            <Row>
                                <Col style={{ alignSelf: "center" }}  >                                    
                                    <b>{t('winbizCloud')} {t('winbizSettings')}</b>
                                    </Col>
                                <Col md="auto"><Button className="btn btn-danger float-end" onClick={goToList} >{t('cancel')}</Button></Col>
                                <Col md="auto"><Button type="submit" className="btn btn-secondary float-end" >{t('save')}</Button></Col>
                            </Row>

                            <hr />

                            
                            <Row className="my-2">
                                <Col xs={3}>
                                    <FormText hidden isNumber id="id" type="number" object={client} />
                                    <FormText required label={t("username")} id="username" isLoading={isLoading} object={config} />
                                </Col>

                                <Col xs={3}>
                                    <FormText required label={t("password")} id="password" type="password" isLoading={isLoading} object={config} />
                                </Col>

                                
                            </Row>

                            <Row className="my-2">                                                              
                                <Col xs={3}>
                                    <FormText required label={t("winbizKey")} id="apiKey" isLoading={isLoading} object={config} />
                                </Col>

                                <Col xs={3}>
                                    <FormText required label={t("winbizCompanyName")} id="companyName" isLoading={isLoading} object={config} />
                                </Col>
                            </Row>

                           

                        </Stack>

                    </div >

                </Card.Body>
            </Card>
        </Form>

    );
};

export default observer(WinbizSettings);
